import React, { useState, useEffect, Fragment } from 'react';

import './CommentList.scss';
import images from '../../shared/assets/images';
import More from '../../shared/assets/icons/more.svg';
import { getItem, removeItem } from '../../helpers/sessionStorage';

const { user: userImage } = images;

export default function CommentList(props) {
  const {
    uri,
    user,
    comments,
    addComment,
    editComment,
    deleteComment,
    showLoginPopup
  } = props;

  const commentNumber = comments.reduce((number, comment) =>
    number + comment.comments.length + 1, 0);

  const [editStateId, setEditStateId] = useState(null);
  const [expandedSubComments, setExpandedSubComments] = useState(new Set());
  const [currentComment, setCurrentComment] = useState({});

  useEffect(() => {
    const userComment = JSON.parse(getItem('userComment'));

    if (userComment) {
      setCurrentComment(userComment);

      removeItem('userComment');
    }
  }, []);

  return (
    <section id="commentList" onClick={e => hideCommentMenu(e)}>
      <div id="commentList_title">
        <h3>Plaats een reactie</h3><span>({commentNumber})</span>
      </div>

      {commentForm()}

      <ul id="commentList_content">{[...comments].sort(sortById).map(comment =>
        <li key={comment.id}>
          <CommentItem
            comment={comment}
            currentUser={user}
            editStateId={editStateId}
            editComment={editComment}
            deleteComment={deleteComment}
            setEditStateId={setEditStateId}
          />

          {!!comment.comments.length &&
            <div className="commentList_replies">
              {expandedSubComments.has(comment.id) ?
                <Fragment>
                  <p onClick={() => toggleSubCommentSection(comment.id)}>
                    Toon minder
                  </p>

                  <ul>
                    {[...comment.comments].sort(sortById).map(subComment =>
                      <li key={subComment.id} data-id={subComment.id}>
                        <CommentItem
                          currentUser={user}
                          comment={subComment}
                          editComment={editComment}
                          editStateId={editStateId}
                          deleteComment={deleteComment}
                          setEditStateId={setEditStateId}
                        />
                      </li>
                    )}
                  </ul>

                  {subCommentForm(comment.id)}
                </Fragment> :
                <Fragment>
                  <h5>Beantwoorden</h5>

                  <p onClick={() => toggleSubCommentSection(comment.id)}>
                    {comment.comments.length} antwoorden bekijken
                  </p>
                </Fragment>
              }
            </div>
          }

          {!comment.comments.length && subCommentForm(comment.id)}
        </li>
      )}</ul>
    </section>
  );

  function commentForm() {
    return (
      <form className="commentList_form" onSubmit={e => postComment(e)}>
        <img src={user.profilePicture || userImage} alt="user-image" />

        <textarea
          rows="4"
          name="message"
          autoComplete="off"
          {...(!currentComment.id && currentComment.message &&
            { defaultValue: currentComment.message })}
          placeholder='Voeg een openbare reactie toe...' />

        <div className="commentList_form_button">
          <button type="submit">Plaats reactie</button>
        </div>
      </form>
    );
  }

  function subCommentForm(parentId) {
    return (
      <form
        onSubmit={e => postComment(e, parentId)}
        className="commentList_form commentList_subcomment">
        <img src={user.profilePicture || userImage} alt="user-image" />

        <textarea
          rows="4"
          name="message"
          autoComplete="off"
          {...(currentComment.id === parentId &&
            { defaultValue: currentComment.message })}
          placeholder='Reageer op antwoord...' />

        <div className="commentList_form_button">
          <button type="submit">Plaats reactie</button>
        </div>
      </form>
    );
  }

  function postComment(e, parentId) {
    e.preventDefault();

    const message = e.target.message.value.trim();

    if (!message) return;

    if (!user.username) {
      sessionStorage.setItem('userComment', JSON.stringify({
        ...(parentId && { id: parentId }), message
      }));

      return showLoginPopup('Log in om een reactie te plaatsen');
    }

    addComment({ variables: {
      message,
      contentUri: uri ,
      authorUserName: user.username,

      ...(parentId && { parentId })
    } });

    e.target.message.value = '';
  }

  function toggleSubCommentSection(id) {
    const newSet = new Set(expandedSubComments);

    if (expandedSubComments.has(id)) newSet.delete(id);
    else newSet.add(id);

    setExpandedSubComments(newSet);
  }
}

function CommentItem(props) {
  const {
    comment,
    editComment,
    editStateId,
    currentUser,
    deleteComment,
    setEditStateId
  } = props;

  const { user, createdAt, authorDisplayName, message, id } = comment;

  const date = new Date(createdAt);

  const isUserComment = user && currentUser.username === user.username;

  const isUserParentComment = isUserComment &&
    comment.comments && !!comment.comments.length;

  const [editedComment, setEditedComment] = useState({});

  const mailto = 'mailto:info@zwangerenportaal.nl?subject=Rapporteren bericht';

  return (
    <div className="commentList_item">
      <div className="commentList_item_header">
        <img src={user ? user.profilePicture : userImage} alt="user-image" />

        <p className="commentList_item_author">
          {authorDisplayName}
        </p>

        <span className="commentList_point">&#8226;</span>

        <span>
          {date.toLocaleString('en-US',
            { day: 'numeric', month: 'short', year: 'numeric' })}
        </span>

        <div className="commentList_menu">
          <span onClick={e => toggleMenu(e)}><More /></span>

          <ul>
            {isUserComment&&
              <li onClick={e => setEditState(e, id, setEditStateId)}>
                Edit
              </li>}

            {isUserComment && !isUserParentComment &&
              <li onClick={() =>
                deleteComment({ variables: { commentId: +id } })}>

                Delete
              </li>}

            <li>
              <a onClick={e => toggleMenu(e)} href={mailto}>
                Rapporteren
              </a>
            </li>
          </ul>
        </div>
      </div>

      {editStateId === +id ?
        <form
          className="commentList_form"
          onSubmit={e => postEditedComment(e)}>
          <input
            autoFocus
            name="message"
            autoComplete="off"
            defaultValue={message}
          />
        </form> :
        <p className="commentList_item_message">
          {editedComment.id === id ? editedComment.message : message}
        </p>
      }
    </div>
  );

  function postEditedComment(e) {
    e.preventDefault();

    const message = e.target.message.value.trim();

    if (!message) return;

    editComment({ variables: { commentId: +id, message } });

    setEditedComment({ id, message });

    setEditStateId(null);
  }
}

function setEditState(e, id, setEditStateId) {
  e.target.closest('.commentList_menu_visible')
    .classList.remove('commentList_menu_visible');

  setEditStateId(+id);
}

function hideCommentMenu(e) {
  if (e.target.closest('.commentList_menu')) return;

  const menu = document.querySelectorAll('.commentList_menu_visible');

  Array.prototype.forEach.call(menu, item =>
    item.classList.remove('commentList_menu_visible'));
}

function sortById(a, b) {
  return a.id > b.id ? -1 : 1;
}

function toggleMenu(e) {
  e.target.closest('.commentList_menu').classList
    .toggle('commentList_menu_visible');
}
